module.exports = __webpack_public_path__ + "0afe29e1d8a03037e7bddf6bfae4625b.png";